// extracted by mini-css-extract-plugin
export default {"backgroundGrey":"execution-main-styles_backgroundGrey__XS6hk","subtitle":"execution-main-styles_subtitle__Pxq32","grey":"execution-main-styles_grey__WihYP"};